//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {echartsUtil} from "../../../utils/echarts-util";
import soilAreaEchartsHeader from "../../business/tobacco-environment-echarts/soil-area-echarts-header";
import soilYearEchartsHeader from "../../business/tobacco-environment-echarts/soil-year-echarts-header";

export default {
	name: "soil-header",
	components: {
		soilAreaEchartsHeader,
		soilYearEchartsHeader
	},
	data() {
		return {
			// 查询项目
			type: '',
			// 指标
			pointerType: '',
			pointerList: [],
			quaDictType: 'tobacco_planting_environment',
		}
	},
	created() {
		this.type = this.quaDictList[0].value;
		this.changeData(this.type);
	},
	computed: {
		dictList() {
			return this.$store.state['tobaccoEnvironmentEcharts'].dictList;
		},
		quaDictList() {
			return this.$store.state['tobaccoEnvironmentEcharts'].quaDictList;
		},
		// 区分选择的图
		headCheck() {
			return this.$store.state['tobaccoEnvironment'].headCheck;
		}
	},
	methods: {
		/**
		 * 更改数据类型
		 * @param val
		 */
		changeData(val) {
			this.pointerList = [];
			this.getType(val);
			// 获取选取值的id
			let id = null;
			this.quaDictList.forEach(item => {
				if (item.value === val) {
					id = item.id;
				}
			})
			// 更改指标类型
			if (id) {
				this.dictList.forEach(item => {
					if (item.parentId === id) {
						this.pointerList.push(item);
					}
				})
				if (this.pointerList.length > 0) {
					this.pointerType = this.pointerList[0].value;
					this.changePointer();
				}
			}
			this.$store.dispatch("tobaccoEnvironment/changePointerList", this.pointerList);
		},

		/**
		 * 获取类型
		 * @param val
		 */
		getType(val) {
			if (val) {
				let temp = [];
				temp.push("1");
				temp.push(val);
				echartsUtil.getType(temp);
			}
		},

		/**
		 * 更改指标
		 */
		changePointer() {
			echartsUtil.changeParamsSingle("pointerType", this.pointerType);
			this.pointerList.forEach(item => {
				if (item.value === this.pointerType) {
					this.$store.dispatch("tobaccoEnvironmentEcharts/changePointerName", item.name);
				}
			})
		},
	}
}
